/**
 * Free Shipping Bar - Pro Version for Dawn
 * Använder Intl.NumberFormat och PubSub
 */
if (!customElements.get('free-shipping-bar')) {
  customElements.define('free-shipping-bar', class FreeShippingBar extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        bar: this.querySelector('.progress-bar-fill'),
        text: this.querySelector('.shipping-text'),
        container: this.querySelector('.free-shipping-wrapper')
      };
    }

    connectedCallback() {
      // Prenumerera på Dawns cart-uppdatering event
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.cartData) {
          this.updateProgress(event.cartData);
        } else {
          this.init();
        }
      });
      
      this.init();
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }

    async init() {
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart.js`);
        const cart = await response.json();
        this.updateProgress(cart);
      } catch (error) {
        console.error('FreeShippingBar: Kunde inte hämta vagn-data', error);
      }
    }

 updateProgress(cart) {
      const cartObj = cart.cartData ? cart.cartData : cart;
      const totalPrice = cartObj.total_price;
      const currency = cartObj.currency || window.Shopify.currency.active;
      
      if (totalPrice === undefined) return;

      // 1. Beräkna limit och procent
      let limit = (currency === 'EUR' ? parseInt(this.dataset.limitEur) : parseInt(this.dataset.limitSek)) * 100;
      const remaining = limit - totalPrice;
      const percentage = Math.min((totalPrice / limit) * 100, 100);
      const percentageString = percentage + '%';

      // 2. Uppdatera mätaren (Både elementet och "minnet" i CSS-variabeln)
      if (this.elements.bar) {
        // Uppdaterar CSS-variabeln på <html> så att den finns kvar om drawern stängs/öppnas
        document.documentElement.style.setProperty('--fsb-progress', percentageString);
        // Uppdaterar det aktuella elementet
        this.elements.bar.style.width = percentageString;
      }

      // 3. Uppdatera texterna
      if (this.elements.text) {
        if (remaining > 0) {
          const formattedRemaining = this.formatMoney(remaining, currency);
          this.elements.text.innerHTML = this.dataset.textPending.replace('[amount]', formattedRemaining);
          this.elements.container.classList.remove('is-free');
        } else {
          this.elements.text.innerHTML = this.dataset.textSuccess;
          this.elements.container.classList.add('is-free');
        }
      }
    }

    formatMoney(cents, currencyCode) {
      // const locale = document.documentElement.lang || 'sv-SE';
      // Vi hårdkodar locale till 'sv-SE' istället för att läsa av sidans språk.
      // Detta tvingar formatet "100 kr" även på den engelska sidan.
      const locale = 'sv-SE';

      const formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode,
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      });

      return formatter.format(Math.ceil(cents / 100));
    }
  }); 
}